import { LinearProgress, Theme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme: Theme) => ({
    loadingQuestion: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "rgba(0, 0, 0, 0.54)"
    },
    text: {
        marginTop: "12rem"
    },
    loadingQuestionWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 0,
        transition: theme.transitions.create("opacity")
    },
    visible: {
        opacity: 1
    },
    loading: {
        width: "200px",
        marginTop: "0.25rem",
        opacity: 0.54
    },
    loadingBar: {
        animation: "1500ms linear 0ms infinite normal none running $indeterminate",
        "&:last-child": {
            display: "none"
        }
    },
    // eslint-disable-next-line local-rules/mui-unused-classes
    "@keyframes indeterminate": {
        "0%": {
            left: "-50%",
            right: "100%"
        },
        "100%": {
            left: "100%",
            right: "-50%"
        }
    },
}));

const QuestionLoadingWidget: React.FC = () => {
    const classes = useStyles();

    const [mountTime, setMountTime] = useState(Number.MAX_SAFE_INTEGER);
    const [, setForceRender] = useState(0);

    useEffect(() => {
        setMountTime(new Date().getTime());
        const interval = setInterval(() => setForceRender(x => x + 1), 10);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={clsx(
            classes.loadingQuestionWrapper,
            mountTime <= new Date().getTime() - 150 && classes.visible
        )}>
            <div className={classes.loadingQuestion}>
                <Typography
                    className={classes.text}
                    variant="body1">
                    Daten werden geladen...
                </Typography>
                <LinearProgress
                    classes={{ bar: classes.loadingBar }}
                    variant="indeterminate"
                    className={classes.loading} />
            </div>
        </div>
    );
};

export default QuestionLoadingWidget;
